import { render, staticRenderFns } from "./OrderTransactions.vue?vue&type=template&id=d7b36b50"
import script from "./OrderTransactions.vue?vue&type=script&lang=js"
export * from "./OrderTransactions.vue?vue&type=script&lang=js"
import style0 from "./OrderTransactions.vue?vue&type=style&index=0&id=d7b36b50&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports